import React from 'react';
import { Link } from 'react-router-dom';

export const parseMoney = (value) => {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') return value;
  const n = Number(String(value).replace(/[^\d.]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

export const formatMoney = (value) => `₹ ${Number(value || 0).toLocaleString('en-IN')}`;

const PackageCard = ({ pkg }) => {
  const id = pkg._id || pkg.id;
  const title = pkg.title || pkg.name || 'Goa Package';
  const current = parseMoney(pkg.currentPrice ?? pkg.price);
  const original = parseMoney(pkg.originalPrice);
  const off = original > current ? original - current : 0;
  const priceText = String(pkg.price || '').trim();

  return (
    <Link to={`/package/${id}`} className="cat-card">
      <div className="cat-card-media">
        <div className="cat-card-img">
          <img src={pkg.image || pkg.images?.[0]} alt={title} />
          {(pkg.featured || pkg.mostSeller) && <span className="cat-badge">Most Seller</span>}
        </div>
        <span className="cat-duration">
          <span aria-hidden="true">⌛</span> {pkg.duration || 'Custom duration'}
        </span>
      </div>
      <div className="cat-card-info">
        <h3 className="cat-title">{title}</h3>
        <div className="cat-price-block">
          <span className="cat-price">
            {current > 0 ? formatMoney(current) : (priceText || 'On request')}
          </span>
          {original > current && (
            <>
              <span className="cat-old">{formatMoney(original)}</span>
              <span className="cat-off">{formatMoney(off)} Off</span>
            </>
          )}
        </div>
        <p className="cat-dates">
          <span aria-hidden="true">📅</span> Dates on Request
        </p>
      </div>
    </Link>
  );
};

export default PackageCard;
